
export const GET_CURRENT_ID = state => state.currentId;

export const GET_POPUP = state => state.popup;

export const SET_FORM = state => state.isActive;

export const GET_SCROLL_PERCENTAGE = state => state.scrollPercentage;




// WEBPACK FOOTER //
// ./src/store/getters.js